import { useEffect, useState } from 'react';
import { io, Socket } from 'socket.io-client';

const OVERLAY_CLASS = 'display-notification-overlay';

export default function DisplayNotificationPage() {
  const [isConnected, setIsConnected] = useState(false);

  useEffect(() => {
    document.documentElement.classList.add(OVERLAY_CLASS);
    document.body.classList.add(OVERLAY_CLASS);

    const root = document.getElementById('root');
    root?.classList.add(OVERLAY_CLASS);

    return () => {
      document.documentElement.classList.remove(OVERLAY_CLASS);
      document.body.classList.remove(OVERLAY_CLASS);
      root?.classList.remove(OVERLAY_CLASS);
    };
  }, []);

  useEffect(() => {
    const socket: Socket = io({
      transports: ['websocket', 'polling'],
    });

    socket.on('connect', () => {
      setIsConnected(true);
    });

    socket.on('disconnect', () => {
      setIsConnected(false);
    });

    return () => {
      socket.disconnect();
    };
  }, []);

  return (
    <div className="min-h-screen pointer-events-none">
      <div className="fixed top-4 right-4 z-50">
        <div
          className={`w-3 h-3 rounded-full ${
            isConnected ? 'bg-emerald-500' : 'bg-red-500 animate-pulse'
          }`}
        />
      </div>
    </div>
  );
}
